import { getRioClient } from '@chegg-me-components/utils';
/* istanbul ignore next */

var rioEndpoint = process.env.NODE_ENV === 'development' ? 'http://localhost:8042/' : 'https://analytics.test.cheggnet.com/rio-service-web/rest/rio-events/batch';
export var config = {
  property: 'chegg',
  endpoint: rioEndpoint,
  authState: 'logged_out',
  appId: 'me-header-component',
  view: {
    experience: 'me',
    property: 'chegg',
    view_name: 'header'
  }
};
export var rioClient = getRioClient();